import { faBomb, faClockRotateLeft } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react"
import { format } from "date-fns"
import { utcToZonedTime } from "date-fns-tz"
import type { CrossQueueItem } from "../routes/microservices-search"

import { Link } from "react-router-dom"

function LocalTimeZone({ time }: { time: string }) {
  try {
    const utcDate = new Date(time)
    const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const localDate = utcToZonedTime(utcDate, localTimeZone)
    return <span className="font-bold">{format(localDate, "yyyy-MM-dd HH:mm:ss zzz")}</span>
  } catch {
    return <span className="font-bold">{time}</span>
  }
}

export const SearchItem = ({ searchItem }: SearchItemProps) => {

  const [showTrace, setShowTrace] = useState(false)

  return (
    <div className="flex w-full flex-col gap-3 rounded-lg border border-accent bg-base-100 p-4 text-base-content text-sm">
      <div className="flex flex-wrap gap-x-6 gap-y-1">
        <p>
          <span className="font-bold">Workflow: </span>
          <span className="font-mono text-xs">{searchItem.workflowId}</span>
        </p>
        <p>
          <span className="font-bold">Step: </span>
          {searchItem.step}
        </p>
        <p>
          <span className="font-bold">Service: </span>
          {searchItem.serviceName}
        </p>
        {searchItem.pod != null && (
          <p>
            <span className="font-bold">Pod: </span>
            {searchItem.pod}
          </p>
        )}
        <p>
          <span className="font-bold">Time: </span>
          <LocalTimeZone time={searchItem.timeStamp} />
        </p>
      </div>
      <div className="grid grid-cols-3 gap-x-4 gap-y-1 text-xs">
        {Object.entries(searchItem.payload).map(([key, value]) => (
          <p key={key} className="flex min-w-0 gap-2">
            <span className="text-base-content/70">{key}:</span>
            <span className="truncate font-bold">
              {typeof value === "object" ? JSON.stringify(value) : String(value as string | number | boolean | bigint | null | undefined)}
            </span>
          </p>
        ))}
      </div>
      {searchItem.stackTrace != null && (
        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={() => setShowTrace(!showTrace)}
            className="flex items-center gap-2 text-left"
          >
            <FontAwesomeIcon icon={faBomb} />
            {showTrace ? "Hide" : "Show"} Trace
          </button>
          {showTrace && (
            <code className="max-h-48 overflow-auto rounded bg-base-200 p-2 text-xs">
              <pre className="whitespace-normal break-words">
                {searchItem.stackTrace
                  .trim()
                  .split("\n")
                  .map((line, i) => (
                    <p key={i}>{line}</p>
                  ))}
              </pre>
            </code>
          )}
        </div>
      )}
      <Link
        to={`/microservices/history?workflowId=${searchItem.workflowId}`}
        title="View workflow history"
        className="grid grid-cols-[max-content,minmax(0,1fr)] items-center justify-start gap-3 text-left"
      >
        <FontAwesomeIcon icon={faClockRotateLeft} />
        <span className="col-start-2">History</span>
      </Link>
    </div>
  )
}

interface SearchItemProps {
  searchItem: CrossQueueItem
}
